import { AppContentView } from 'Components/AppLayout';
import PropTypes from 'prop-types';

const BiobankLanding = ({
  title = '',
  titleButton,
  breadcrumbs = [],
  children,
}) => {
  let allBreadcrumbs = [...breadcrumbs];

  return (
    <AppContentView
      title={title}
      titleButton={titleButton}
      breadcrumbs={breadcrumbs ? allBreadcrumbs : undefined}>
      {children}
    </AppContentView>
  );
};

BiobankLanding.propTypes = {
  title: PropTypes.string,
  titleButton: PropTypes.node,
  breadcrumbs: PropTypes.array,
  children: PropTypes.node,
};

export default BiobankLanding;
